import ContentModel from '@/dex-shared/models/ContentModel';
import TextModel from '@/dex-shared/models/TextModel';
import ImageModel from '@/dex-shared/models/ImageModel';

export default {
  imageById: (state: any, getters: any) => (imageId: number) => {
    const image = state.images[imageId];
    if (image) {
      return new ImageModel(image, getters);
    } else {
      return {};
    }
  },
  contentById: (state: any, getters: any) => (contentId: number) => {
    const content = state.contents[contentId];
    if (content) {
      return new ContentModel(content, getters);
    } else {
      return {};
    }
  },
  textById: (state: any, getters: any) => (textId: number) => {
    const text = state.texts[textId];
    if (text) {
      return new TextModel(text, getters);
    } else {
      return {};
    }
  },
};
